import { useEffect, useState } from "react";

/**
 * Ticks real elapsed time (in seconds) since `startedAt`, once a second —
 * no network call, just wall-clock math against a server-stamped
 * timestamp. Shared by RadioPlayer's progress bar and UpNextCard's
 * estimated play-time column so both tick off the same real clock
 * instead of two slightly-drifting copies of the same math.
 */
export function useElapsedSeconds(startedAt: string | null | undefined): number {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!startedAt) {
      setElapsed(0);
      return;
    }
    const startedAtMs = new Date(startedAt).getTime();
    function tick() {
      setElapsed((Date.now() - startedAtMs) / 1000);
    }
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [startedAt]);

  return elapsed;
}
